import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "@app/sass/style.scss";
import Root, { loader as rootLoader } from "@app/routes/root.jsx";
import Index, { loader as indexLoader } from "@app/routes/index.jsx";
import Offices, { loader as officesLoader, action as officesAction } from "@app/routes/offices.jsx";
import InspectionLayout, { loader as inspectionLoader } from "@app/routes/inspection/layout.jsx";
import InspectionFormStep, {
	updateInspectionAction,
	newInitialAction,
	newFollowUpAction,
	loader as inspectionFormStepLoader,
} from "@app/routes/inspection/form-step.jsx";
import NewFollowUp from "@app/routes/inspection/new-follow-up.jsx";
import Inspections, { action as inspectionsAction, loader as inspectionsLoader } from "@app/routes/inspections.jsx";
import Summary, { action as summaryAction, loader as summaryLoader } from "@app/routes/inspection/summary.jsx";
import Confirmation, { action as confirmationAction } from "@app/routes/inspection/confirmation.jsx";
import RootErrorBoundary from "@app/components/RootErrorBoundary/RootErrorBoundary";
import ThankYou from "@app/routes/inspection/thankyou.jsx";
import Config from "@app/constants/Config";
import BlockingLoader from "@app/components/BlockingLoader";
import Archive from "@app/routes/inspection/archive.jsx";
import Feedback, { action as feedbackAction } from "@app/routes/feedback.jsx";

const router = createBrowserRouter([
	{
		path: Config.BASE_PATH,
		element: <Root />,
		children: [
			{
				// errorElement: <ErrorPage />,
				id: "root",
				errorElement: <RootErrorBoundary />,
				loader: rootLoader,
				children: [
					{
						index: true,
						element: <Index />,
						id: "home",
						loader: indexLoader,
					},
					{
						path: "office",
						element: <Offices />,
						action: officesAction,
						loader: officesLoader,
						id: "office",
					},
					{
						path: "feedback",
						element: <Feedback />,
						id: "feedback",
						action: feedbackAction,
					},
					{
						path: "inspection",
						element: <InspectionLayout />,
						loader: inspectionLoader,
						id: "inspection",
						children: [
							{
								path: "new-initial",
								element: <InspectionFormStep />,
								loader: inspectionFormStepLoader,
								action: newInitialAction,
							},
							{
								path: "new-follow-up/:inspectionId",
								element: <NewFollowUp />,
								// loader: inspectionFormStepLoader,
								action: newFollowUpAction,
							},
							{
								path: ":inspectionId",
								element: <InspectionFormStep />,
								loader: inspectionFormStepLoader,
								action: updateInspectionAction,
							},
							{
								path: ":inspectionId/:step",
								element: <InspectionFormStep />,
								loader: inspectionFormStepLoader,
								action: updateInspectionAction,
							},
							{
								path: ":inspectionId/summary",
								element: <Summary />,
								loader: summaryLoader,
								action: summaryAction,
							},
							{
								path: ":inspectionId/confirmation",
								element: <Confirmation />,
								loader: summaryLoader,
								action: confirmationAction,
							},
							{
								path: ":inspectionId/thankyou",
								element: <ThankYou />,
							},
							{
								path: ":inspectionId/archive",
								element: <Archive />,
								loader: summaryLoader,
							},
						],
					},
					{
						path: "inspections/:filter?",
						element: <Inspections />,
						loader: inspectionsLoader,
						action: inspectionsAction,
					},
				],
			},
			/* the rest of the routes */
		],
	},
]);

ReactDOM.createRoot(document.getElementById("app")).render(
	<React.StrictMode>
		<RouterProvider router={router} fallbackElement={<BlockingLoader loading={true} />} />
	</React.StrictMode>,
);
